import React from 'react';

const renderFieldRadio = ({ input, label, type,value,meta: { touched, error } }) => (
  <div className="form-group">
    <div className="radio">  
      <label>
          <input {...input} type={type} value={input.value}/>
        {label}
         {touched && error && <span className="text-danger">{error}</span>}
        </label>
    </div>

  </div>
);

export default renderFieldRadio;



// WEBPACK FOOTER //
// ./src/container/renderFieldRadio.js